import { render, staticRenderFns } from "./DeleteableChip.vue?vue&type=template&id=05921ab6&scoped=true"
import script from "./DeleteableChip.vue?vue&type=script&lang=ts"
export * from "./DeleteableChip.vue?vue&type=script&lang=ts"
import style0 from "./DeleteableChip.vue?vue&type=style&index=0&id=05921ab6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05921ab6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05921ab6')) {
      api.createRecord('05921ab6', component.options)
    } else {
      api.reload('05921ab6', component.options)
    }
    module.hot.accept("./DeleteableChip.vue?vue&type=template&id=05921ab6&scoped=true", function () {
      api.rerender('05921ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/chips/DeleteableChip.vue"
export default component.exports